import { Box, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ImageLazyLoader from "../../components/common/ImageLazyLoader";
import OrderInfo from "../../components/Order/OrderInfo/OrderInfo";
import AppNavbar from "../../components/shared/AppNavbar/AppNavbar";
import LeftArrow from "../../images/arrow-left_grey.svg";
import {
  CATEGORY_ITEM_TYPE,
  CategoryItem,
  Restaurant,
} from "../../interfaces/Catalogue";
import { shopApi } from "../../services/apiGate";
import { catalogueApi } from "../../services/catalogueApi";
import "./OrderPage.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootState";

const OrderPage = () => {
  const navigate = useNavigate();
  const { restaurantId, categoryId, categoryItemType, categoryItemId } =
    useParams();
  const menuPage = true;
  const [isMobile, setIsMobile] = useState(false);
  const [categoryItem, setCategoryItem] = useState<CategoryItem>();
  const [restaurant, setRestaurant] = useState<Restaurant>();
  const [loading, setLoading] = useState(false);
  const [establishementToken, setEstablishementToken] = useState(
    localStorage.getItem("establishementToken")
  );
  const selectedMode = useSelector(
    (state: RootState) => state.app.selectedMode
  );

  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        const response = await shopApi.getResturantById({
          id: Number(restaurantId),
          diningMode: Number(selectedMode),
          adresse: {
            latitude: 0,
            longitude: 0,
          },
        });
        const azureUrl = response?.data?.restaurant?.azureUrl;

        const tokenRes = await catalogueApi.getEstablishementToken(azureUrl);
        const newToken = tokenRes.data.data.result;

        localStorage.setItem("establishementToken", newToken);
        setEstablishementToken(newToken);
        setRestaurant(response.data?.restaurant);
      } catch (error) {
        console.error("Error fetching restaurant:", error);
      }
    };

    if (restaurantId) {
      fetchRestaurant();
    }
  }, [restaurantId]);

  useEffect(() => {
    const fetchCategoryItem = async () => {
      try {
        setLoading(true);
        const fetchFunction =
          categoryItemType === CATEGORY_ITEM_TYPE.ARTICLE
            ? catalogueApi.GetArticleById
            : categoryItemType === CATEGORY_ITEM_TYPE.MENU
              ? catalogueApi.GetMenuById
              : null;

        if (!fetchFunction) {
          throw new Error("Invalid category item type");
        }

        let response;

        // Explicitly define the function signature to ensure correct argument passing
        if (categoryItemType === CATEGORY_ITEM_TYPE.ARTICLE && restaurant?.id) {
          response = await (
            fetchFunction as (
              id: number,
              categoryId: number,
              restaurantId: number
            ) => Promise<any>
          )(Number(categoryItemId), Number(categoryId), restaurant.id);
        } else {
          response = await (
            fetchFunction as (id: number, categoryId: number) => Promise<any>
          )(Number(categoryItemId), Number(categoryId));
        }

        let item: CategoryItem = response?.data?.data?.result;
        item.categoryId = Number(categoryId);
        setCategoryItem(item);
      } catch (error: any) {
        console.error("🚀 ~ fetchCategoryDetails ~ error:", error);
        // const errorCodeFI = error.response?.data?.failureResponse?.codeFI?.code;
        // const errorCodeReq = error.response?.status;
        // setError(errorCodeFI || errorCodeReq);
      } finally {
        setLoading(false);
      }
    };

    if (categoryItemType && establishementToken && restaurant) {
      fetchCategoryItem();
    }
  }, [categoryItemType, establishementToken, restaurant?.id]);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the pixel value as needed
    };

    checkMobile(); // Check on initial render
    window.addEventListener("resize", checkMobile); // Update on resize

    return () => window.removeEventListener("resize", checkMobile); // Cleanup
  }, []);

  return (
    <div id="orderPage">
      <AppNavbar menuPage={menuPage} />
      <div className="BodyPage">
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            gap: 1,
          }}
        >
          <div className="TopPageHeader">
            <div>
              <img
                onClick={() => {
                  navigate(`/restaurant/${restaurantId}`, {
                    state: {
                      currentCategoryId: categoryId,
                    },
                  });
                }}
                src={LeftArrow}
                alt=""
              />

              <p>{categoryItem?.designation}</p>
            </div>
          </div>
        </Box>

        <div className="orderView full-size row">
          {/* Left section */}
          {!isMobile && (
            <div className="leftSection column">
              <div className="imgContainer">
                <ImageLazyLoader
                  alt={categoryItem?.designation || restaurant?.nom}
                  src={categoryItem?.imgUrl || ""}
                  effect="blur"
                  className="full-size"
                />
              </div>
            </div>
          )}

          <Stack className="rightSection column" spacing={2}>
            {/* Right section */}
            {restaurant && categoryItem ? (
              <OrderInfo
                categoryItemType={categoryItemType}
                categoryItem={categoryItem}
                categoryId={categoryId}
                restaurant={restaurant}
              />
            ) : (
              <div className="orderLoading"></div>
            )}
          </Stack>
        </div>
      </div>
      {/* {config?.isGlobalWebsite && <Footer />} */}
    </div>
  );
};

export default OrderPage;
